import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CounsellingDashboardLandingComponent } from './counselling-dashboard-landing/counselling-dashboard-landing.component';
import { CounsellingDashboardLinksComponent } from './counselling-dashboard-links/counselling-dashboard-links.component';
import { CounsellingDashboardComponent } from './counselling-dashboard/counselling-dashboard.component';

const routes: Routes = [
  {
    path:'',component:CounsellingDashboardLinksComponent,
    children:[
      {
        path:"studentcounsellingdashboard", component:CounsellingDashboardComponent

      },
      
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CounsellingDashboardRoutingModule { }
